import React from 'react';
import Hero from '../components/Hero';
import PromoBanner from '../components/PromoBanner';
import Services from '../components/Services';
import Contact from '../components/Contact';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <PromoBanner />
      <Services />
      <Contact />
    </>
  );
};

export default HomePage;